import { createFileRoute } from "@tanstack/react-router";

import type { ChildRouteContext } from "@/root";
import { throwIfHasNoPermission } from "@/utils/permissions";

import ReviewFormBuilder from "@/modules/performance/admin/components/review-form/ReviewFormBuilder";

export const Route = createFileRoute(
  "/admin/_panel/_performance/performance/reviews/forms/create",
)({
  component: Component,
  beforeLoad: ({ context }) => {
    throwIfHasNoPermission(
      context.user,
      "performance.performance-review-form.create",
    );

    return {
      compactMenu: true,
      hideCrumb: true,
      crumb: [
        {
          label: context.t("Create", { ns: "core.shared" }),
        },
      ],
    } satisfies ChildRouteContext;
  },
});

function Component() {
  return <ReviewFormBuilder />;
}
